/**
 * Vite equivalent of webpack's require.context()
 * Loads images from the /src/Banderas directory and provides a function
 * to access them by filename (case-insensitive lookup).
 *
 * Usage:
 *   const logoImage = createImageLoader('../Banderas');
 *   const imageSrc = logoImage('./LOGO.png');
 *   const imageSrc = logoImage('./mexico.png'); // works even if file is Mexico.png
 */

// Eagerly import every file under /src/Banderas at module load time.
const _modules = import.meta.glob('/src/Banderas/**/*', {
  eager: true,
  import: 'default',
});

// Build a case-insensitive lookup map: lowercase filename → resolved URL.
// Key format: "logo.png", "mexico.png", etc.
const _byFilename = Object.fromEntries(
  Object.entries(_modules).map(([path, url]) => {
    const filename = path.split('/').pop().toLowerCase();
    return [filename, url];
  })
);

export const createImageLoader = (/* globPattern — kept for API compatibility */) => {
  return (filename) => {
    if (!filename) return '';

    // Strip leading "./" and normalise to lowercase for lookup
    const normalized = filename.replace(/^\.\//, '').toLowerCase();

    const url = _byFilename[normalized];

    if (!url) {
      console.warn(`[imageLoader] Image not found: "${filename}"`);
      return '';
    }

    return url;
  };
};
